import React, { useState } from "react";
import style from "./SpecialChanceDescription.module.css";
import Modal from "../../components/modal/Modal";

import ShareBox from "../../components/shareButton/ShareBox";
import { useAppSelector } from "../../store/hooks";

interface ruleProp {
  onClose: () => void;
  isModal: boolean;
}

const SpecialChanceDescriptionModal: React.FC<ruleProp> = ({
  onClose,
  isModal,
}) => {
  const user = useAppSelector((state) => state.login.user.data?.data?.user);

  return (
    <Modal
      className={`${style["rule-modal"]} desktop`}
      overlayClass={style["rule-modal-overlay"]}
      onClose={onClose}
      animation="slide-left"
      isModal={isModal}
    >
      <div className={style["modal-container"]}>
        <img
          src={`${process.env.PUBLIC_URL}/assets/icon/x.svg`}
          alt=""
          className={style["close-icon"]}
          onClick={() => {
            onClose();
          }}
        />
        <img
          src={`${process.env.PUBLIC_URL}/assets/icon/sad-gold-heart.svg`}
          alt=""
          style={{ marginBottom: 20 }}
        />
        <span style={{ color: "#384B70", fontSize: 16, fontWeight: 600 }}>
          شانس ویژه نداری!
        </span>

        <ul className={style["modal-list"]}>
          <li>
            برای چرخوندن گردونه جوایز ویژه بانی‌مد حتما باید "شانس ویژه" داشته
            باشی که فقط از طریق دعوت دوست به بازی به دست میاد.
          </li>
          <li>
            با دعوت از هر دوست غیربانی‌مدی 5 شانس بازی و 5 شانس ویژه دریافت
            می‌کنی.
          </li>
          <li>
            با دعوت از هر دوست بانی‌مدی 2 شانس بازی و 2 شانس ویژه دریافت می‌کنی.
          </li>
          <li>
            دوست بانی‌مدی کسیه که قبلا عضو بانی‌مد شده و دوست غیربانی‌مدی کسیه
            که عضو بانی‌مد نبوده و از طریق لینک دعوت تو به خانواده بانی‌مد ملحق
            می‌شه.
          </li>
        </ul>
        <div style={{ width: "100%" }}>
          <ShareBox id={user?.refId!} isSpecial />
        </div>
      </div>
    </Modal>
  );
};

export default SpecialChanceDescriptionModal;
